import { Datum } from '../types'
import { isValidNumber } from '../charts/share/utils'

export const valueFormatter = (value: Datum['value'] | undefined) => {
  if (!isValidNumber(value)) return value || ''
  const compactFormat = Intl.NumberFormat('en-US', {
    notation: 'compact',
    maximumFractionDigits: 1,
    // @ts-ignore
    // Don't know why Safari(15.6.1+) doesn't honor maximumFractionDigits.
    // Therefore, the experimental roundingPriority is added to force Safari to use the result calculated from maximumFractionDigits.
    roundingPriority: 'lessPrecision'
  })
  const thousandFormat = Intl.NumberFormat('en-US')
  return value > 1000 ? compactFormat.format(value) : thousandFormat.format(value)
}

export interface PercentFormatterOptions {
  replaceInvalidNumberWith?: string | number
}

export const percentFormatter = (
  value: Datum['value'] | undefined,
  options?: PercentFormatterOptions
) => {
  if (options?.replaceInvalidNumberWith != null) {
    return `${isValidNumber(value) ? value : options.replaceInvalidNumberWith}%`
  }

  return isValidNumber(value) ? `${value}%` : value || ''
}
